import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import _type_of from "@swc/helpers/src/_type_of.mjs";
import { constants } from "@cinch-nx/data-search";
import { convertFilterValueToUrlSegment, getOrderedParsedFilterMap, truncateSegmentsToQueryParams } from "../../utils";
var DEFAULT_PAGE_SIZE = constants.DEFAULT_PAGE_SIZE, DEFAULT_SORTING_CRITERIA = constants.DEFAULT_SORTING_CRITERIA, nonFilterParamKeys = constants.nonFilterParamKeys, searchFilterKeys = constants.searchFilterKeys, searchParamKeys = constants.searchParamKeys, validUrlSegmentFilterKeys = constants.validUrlSegmentFilterKeys;
function addNonFilterParamToUrlParams(key, value, urlSearchParams) {
    switch(key){
        case "pageNumber":
            if (value !== 1) {
                urlSearchParams.set("pageNumber", "".concat(value));
            }
            break;
        case "pageSize":
            if (value !== DEFAULT_PAGE_SIZE) {
                urlSearchParams.set("pageSize", "".concat(value));
            }
            break;
        case "sortingCriteria":
            if (value !== DEFAULT_SORTING_CRITERIA) {
                urlSearchParams.set("sortingCriteria", "".concat(value));
            }
            break;
        case "useMonthly":
            if (value) {
                urlSearchParams.set("useMonthly", "".concat(value));
            }
            break;
    }
}
function isNonFilterParamKey(key) {
    return nonFilterParamKeys.includes(key);
}
function isValidSegmentFilterKey(key) {
    return validUrlSegmentFilterKeys.includes(key);
}
function isStringArray(value) {
    return Array.isArray(value);
}
export function mapFiltersToUrl(filters, allCinchStores) {
    var existingParams = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new URLSearchParams(window.location.search);
    // remove un-set filters/params & convert to map of filter key/values & urlSearchParams
    var ref = Object.entries(filters).reduce(function(param, param1) {
        var urlPathMap = param.urlPathMap, urlSearchParams = param.urlSearchParams, _param = _sliced_to_array(param1, 2), key = _param[0], value = _param[1];
        if (isNonFilterParamKey(key)) {
            // special handling of non-filter params, don't include them in the url when the value is the default
            addNonFilterParamToUrlParams(key, value, urlSearchParams);
            return {
                urlPathMap: urlPathMap,
                urlSearchParams: urlSearchParams
            };
        }
        if (!isStringArray(value)) {
            console.warn("Unexpected type value for key '".concat(key, "', expected string[] but got ").concat(typeof value === "undefined" ? "undefined" : _type_of(value)));
            return {
                urlPathMap: urlPathMap,
                urlSearchParams: urlSearchParams
            };
        }
        // when all possible stores are selected, show 'all-stores' in the URL params rather than listing them all
        if (key === "store" && allCinchStores.length > 0 && value.length === allCinchStores.length && allCinchStores.every(function(storeValue) {
            return value.includes(storeValue);
        })) {
            urlSearchParams.set(key, "all-stores");
        } else if (value.length === 1 && isValidSegmentFilterKey(key)) {
            // single value filters that are allowed in the URL segments should be added to the urlPathMap
            urlPathMap.set(key, {
                searchApiValue: convertFilterValueToUrlSegment(key, value[0]),
                urlSegmentValue: value[0]
            });
        } else if (value.length > 1 || value.length === 1 && !isValidSegmentFilterKey(key)) {
            // multi-value filters and those not allowed in URL segments are added to the search params
            urlSearchParams.set(key, value.join(","));
        }
        return {
            urlPathMap: urlPathMap,
            urlSearchParams: urlSearchParams
        };
    }, {
        urlPathMap: new Map(),
        urlSearchParams: new URLSearchParams()
    }), urlPathMap = ref.urlPathMap, urlSearchParams = ref.urlSearchParams;
    // sort segments
    var ref1 = getOrderedParsedFilterMap(urlPathMap), sortedParsedPath = ref1.orderedParsedFilterMap;
    // truncate segments to 3 & convert extras to query parameters
    var ref2 = truncateSegmentsToQueryParams({
        orderedParsedFilterMap: sortedParsedPath,
        maxAllowedSegments: 3
    }), trimmedSortedParsedPath = ref2.truncatedOrderedParsedPath, additionalQueryParams = ref2.additionalQueryParams;
    // append additionalQueryParams to urlSearchParams
    additionalQueryParams.forEach(function(_, key) {
        if (searchFilterKeys.includes(key)) {
            // get the value from the original filters rather than the search params, as we don't want the
            // transformed for url segment value in search params, we want the raw one
            urlSearchParams.set(key, filters[key].join(","));
        }
    });
    // Add any existing non-filter URL search params
    existingParams.forEach(function(value, key) {
        if (!searchParamKeys.includes(key)) {
            urlSearchParams.set(key, value);
        }
    });
    // combine trimmedSortedParsedPath into a URL
    var urlPathSegments = _to_consumable_array(trimmedSortedParsedPath.values());
    // convert slashes into dashes to prevent segment overloading
    var sanitisedUrlPathSegments = urlPathSegments.map(function(s) {
        return s.searchApiValue.replace(/\//g, "-").replace(/\[/g, "(").replace(/]/g, ")");
    });
    // Join the segments...
    var urlPath = sanitisedUrlPathSegments.join("/");
    // if we've got any search params, add them
    if (_to_consumable_array(urlSearchParams.values()).length > 0) {
        urlPath += "?".concat(urlSearchParams);
    }
    return urlPath;
}
